import { render } from "./EventTemplateModal.vue?vue&type=template&id=09b838d4&scoped=true"
import script from "./EventTemplateModal.vue?vue&type=script&lang=js"
export * from "./EventTemplateModal.vue?vue&type=script&lang=js"

import "./EventTemplateModal.vue?vue&type=style&index=0&id=09b838d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b838d4"],['__file',"src/containers/event/eventSettings/EventTemplateModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09b838d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09b838d4', __exports__)) {
    api.reload('09b838d4', __exports__)
  }
  
  module.hot.accept("./EventTemplateModal.vue?vue&type=template&id=09b838d4&scoped=true", () => {
    api.rerender('09b838d4', render)
  })

}


export default __exports__